import { Navigate, Route, Routes } from 'react-router-dom';

import Conversation from 'components/conversation/containers/conversation';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';

import { LayoutView } from './layout.view';
import { AnalyticsRoutes } from './views/analytics';
import { ContactsRoutes } from './views/contacts';
import { ConversationView } from './views/conversation';
import { ConversationsView } from './views/conversations';
import { DashboardRoutes } from './views/dashboard';
import { DraftsView } from './views/drafts';
import {
  KnowledgeDeliveryRoutes,
  KnowledgeManagementRoutes,
} from './views/knowledge';
import { NotFoundView } from './views/notFound';
import { NotificationsView } from './views/notifications';
import { SearchRoutes } from './views/search';
import { SettingsRoutes } from './views/settings';
import { TeamView } from './views/team';

/** The layout routes of the application. */
export const LayoutRoutes = (): JSX.Element => {
  const { phoenixConversation, knowledgeAccess } = useFeatureFlag([
    'phoenix-conversation',
    'knowledge-access',
  ]);

  return (
    <LayoutView>
      <Routes>
        <Route path="/" element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard/*" element={<DashboardRoutes />} />

        <Route path="conversations" element={<ConversationsView />} />

        <Route
          path="conversation/:csid"
          element={
            phoenixConversation ? <ConversationView /> : <Conversation />
          }
        />

        <Route path="team" element={<TeamView />} />
        <Route path="analytics/*" element={<AnalyticsRoutes />} />
        <Route path="notifications" element={<NotificationsView />} />
        <Route path="drafts" element={<DraftsView />} />

        {knowledgeAccess && (
          <>
            <Route path="knowledge/*" element={<KnowledgeManagementRoutes />} />
            <Route path="internal-kb/*" element={<KnowledgeDeliveryRoutes />} />
          </>
        )}

        <Route path="contacts/*" element={<ContactsRoutes />} />
        <Route path="search/*" element={<SearchRoutes />} />
        <Route path="settings/*" element={<SettingsRoutes />} />

        <Route
          path="*"
          element={
            <NotFoundView navigatePath="/conversations" name="conversations" />
          }
        />
      </Routes>
    </LayoutView>
  );
};
